import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import icon1 from "./img/icon1.svg";
import icon2 from "./img/icon2.svg";
import icon3 from "./img/icon3.svg";
import icon4 from "./img/icon4.svg";
import icon5 from "./img/icon5.svg";
import icon6 from "./img/icon6.svg";
import icon7 from "./img/icon7.svg";
import icon8 from "./img/icon8.svg";
import {
  FaCalendarDays,
  FaCartShopping,
  FaClipboardQuestion,
  FaHeartPulse,
  FaIdCard,
  FaThumbsUp,
} from "react-icons/fa6";
import { BiSolidDish } from "react-icons/bi";
import { MdFlight } from "react-icons/md";

const useCases = [
  {
    title: "Placing Orders",
    description:
      "Collect product choices, quantitiesand delivery preferences through the form. Integrate payment options for a smooth and complete shopping experience.",
    icon: <FaCartShopping size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Event Registration",
    description:
      "Design the form to capture attendee details, then confirm their registration and send event information directly via WhatsApp.",
    icon: <FaCalendarDays size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Booking Appointments",
    description:
      "Customize forms for your health center and gather key details like the customer’s name, contact infoand preferred appointment time. Automatically confirm the booking through WhatsApp.",
    icon: <FaHeartPulse size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Restaurant Reservations",
    description:
      "Use the form to collect reservation specifics such as date, timeand party size. Confirm and manage these reservations automatically.",
    icon: <BiSolidDish size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Gathering Client Feedback",
    description:
      "Design the form to request ratings, commentsand suggestions from clients. Automate the collection and analysis of feedback to improve services.",
    icon: <FaThumbsUp size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Quotation Request",
    description:
      "Use the form to capture customer preferences (such as size, quantity) and offer customized quotes for any scenario.",
    icon: <FaClipboardQuestion size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "General Contact Form",
    description:
      "Collect contact information and the purpose of the inquiry. Provide instant acknowledgment and route the message to the relevant team.",
    icon: <FaIdCard size={32} color={"rgb(255,255,255,0.8)"} />,
  },
  {
    title: "Travel Booking",
    description:
      "Simplify travel arrangements and add a personal touch to customer service with WhatsApp Flow’s intuitive booking features.",
    icon: <MdFlight size={32} color={"rgb(255,255,255,0.8)"} />,
  },
];

const WhatsAppFormUseCase = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        backgroundImage: `url('bg3.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        py: { xs: 4, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mb: { xs: 2, md: 4 },
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: "2rem", md: "3rem" },
              color: "rgb(255,255,255)",
              textAlign: 'center',
            }}
          >
            WhatsApp Forms Use-Cases
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "rgb(255,255,255, 0.7)",
              fontSize: { xs: "1.2rem", md: "1.5rem" },
              textAlign: 'center',
            }}
          >
            Here’s how you can effectively use a WhatsApp Lead Generation Form
            for different scenarios:
          </Typography>
          {/* <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#00C851",
              color: "#fff",
              textTransform: "none",
              fontWeight: "bold",
              px: 3,
              py: 1.5,
              "&:hover": { backgroundColor: "#00b34d" },
            }}
          >
            Talk to Sales
          </Button> */}
        </Box>

        <Grid container spacing={3}>
          {useCases.map((useCase, index) => (
            <Grid key={index} item xs={12} sm={6}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "flex-start",
                  mb: 3,
                  backgroundColor: "rgb(255,255,255, 0.1)",
                  backdropFilter: "blur(10px)",
                  height: "100%",
                  px: 4,
                  py: 2,
                  borderRadius: "10px",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: 4,
                    cursor: "pointer",
                  },
                }}
              >
                <Box sx={{ mt: 0.5, width: 36, height: 36 }}>
                  {useCase.icon}
                </Box>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, md: 18 },
                      color: "rgb(255,255,255, 0.9)",
                    }}
                  >
                    {useCase.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "rgb(255,255,255, 0.7)",
                      mt: 0.5,
                      fontSize: { xs: 14, md: 16 },
                      lineHeight: 1.6,
                    }}
                  >
                    {useCase.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhatsAppFormUseCase;
